module.exports = __webpack_public_path__ + "img/launch_tesseract_with_cmd.2d8a44f1.png";